import React, { useEffect, useState } from "react";
import { useAuth } from '../../store/AuthContext';  


const API_URL = process.env.REACT_APP_API_URL;

export default function ViewRatings() {
 
   const { user } = useAuth();   // Get logged-in user
  const [ratings, setRatings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    async function fetchRatings() {
   if (!user?.id) {
      setError('User not logged in.');
              setLoading(false);

      return;
    }
     

      try {
        const res = await fetch(`${API_URL}/api/teacher/rating/${user.id}`);
        if (!res.ok) {
          throw new Error(`Server responded with status ${res.status}`);
        }

        const data = await res.json();
        console.log("Fetched data:", data);

        // Check if data is array or wrapped inside an object (e.g. { ratings: [...] })
        if (Array.isArray(data)) {
          setRatings(data);
        } else if (Array.isArray(data.ratings)) {
          setRatings(data.ratings);
        } else {
          setError("Unexpected data format from server.");
        }
      } catch (err) {
        console.error("Failed to fetch ratings:", err);
        setError("Failed to fetch ratings.");
      } finally {
        setLoading(false);
      }
    }

    fetchRatings();
  }, [user.id]);

  const averageRating = ratings.length
    ? (ratings.reduce((acc, r) => acc + r.rating, 0) / ratings.length).toFixed(1)
    : null;

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Student Ratings</h1>

      {loading && <p>Loading ratings...</p>}
      {error && <p className="text-red-500">{error}</p>}
      {!loading && !error && ratings.length === 0 && <p>No ratings yet.</p>}

      {averageRating && (
        <h2 className="text-xl font-semibold mb-2">
          Average Rating: {averageRating} ⭐
        </h2>
      )}

      <ul>
        {ratings.map(({ _id, studentId, rating, comment, ratedAt }) => (
          <li key={_id} className="mb-4 border p-4 rounded shadow">
            <p>
              <strong>{studentId?.name || "Anonymous"}</strong> rated: {rating} ⭐
            </p>
            <p>{comment}</p>
            <p className="text-sm text-gray-500">
              {new Date(ratedAt).toLocaleDateString()}
            </p>
          </li>
        ))}
      </ul>
    </div>
  );
}
